import React from "react";

// Full-screen looping video background with a readability overlay.
// The overlay sits BETWEEN the video and the UI (both video + overlay at
// z-index:-1, overlay painted after the video so backdrop-filter blurs the
// video, never the UI). Navy tint (20-30%) + blur(5px) keeps the motion visible
// while making Bebas Neue text and buttons much easier to read.
// The parent screen root must establish a stacking context (position:relative; z-index:0).
export const VideoBg = ({ src, testid, overlay }) => {
  const tint = overlay != null ? Math.max(overlay, 0.24) : 0.28;
  return (
    <>
      <video
        data-testid={testid}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        aria-hidden
        className="animate-bg-fade"
        style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: -1, pointerEvents: "none", filter: "saturate(1.22) contrast(1.06) brightness(1.03)" }}
        src={src}
      />
      <div
        aria-hidden
        style={{
          position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: -1, pointerEvents: "none",
          background: `rgba(14, 18, 40, ${tint})`,
          backdropFilter: "blur(5px)",
          WebkitBackdropFilter: "blur(5px)",
        }}
      />
    </>
  );
};
